// extracted by mini-css-extract-plugin
export default {"loader":"LoaderBase_loader__uUWL8","spinning":"LoaderBase_spinning__eKpIs"};